import { useCurrentUserProfile } from "@/hooks/useUsers";

/**
 * Where "Clientes" is for the current user.
 *
 * The screen is one component (`ClientsList`) served at two paths, each with its own
 * route guard: super-admins own `/super-admin/clients`, account managers `/clients`.
 * Both roles now share the onboarding wizard and the deployment editor, and those
 * pages have to send the operator back to the one they may actually open — sending an
 * account manager to the super-admin path bounces them to the pipeline instead.
 */
export function useClientsPath(): string {
  const profile = useCurrentUserProfile();
  return profile?.role === "account_manager" ? "/clients" : "/super-admin/clients";
}
